// Estilos do modal de salvar/renomear template
const styles = () => ({
  // Cabeçalho com título à esquerda e fechar à direita
  modalTitle: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  nomeField: { mb: 2 },
  descricaoField: { mb: 1 },
  // Aviso do que entra (e não entra) no template
  resumoHint: {
    fontSize: 12,
    color: "text.secondary",
  },
});

export default styles;
